import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export enum AlertMessageTypeEnum {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
  Success = 'success',
}

@Component({
  selector: 'lib-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIcon],
})
export class AlertMessageComponent {
  type = input<'error' | 'warning' | 'info' | 'success'>(AlertMessageTypeEnum.Info);
  text = input<string>();
  inline = input<boolean>(false);
  iconOverride = input<string>('');
  variant = input<'default' | 'order-limit'>('default');
  /** Optional typography class; falls back to the variant's own (the PDP notice asks for 14px). */
  typography = input<string>('');
  /** Figma sizes the order-limit icon at 12px; the order-limit variant implies it. */
  iconSize = input<'default' | 'small'>('default');

  private iconMap: { [key in AlertMessageTypeEnum]?: string } = {
    [AlertMessageTypeEnum.Error]: 'ico_info',
    [AlertMessageTypeEnum.Warning]: 'ico_soft',
    [AlertMessageTypeEnum.Info]: 'ico_info',
    [AlertMessageTypeEnum.Success]: 'ico_checkmark',
  };

  icon = computed(() => this.iconOverride() || this.iconMap[this.type()] || AlertMessageTypeEnum.Info);
  inlineClass = computed(() => (this.inline() ? 'inline' : ''));
  variantClass = computed(() => (this.variant() === 'order-limit' ? 'order-limit' : ''));
  iconSizeClass = computed(() => (this.iconSize() === 'small' || this.variant() === 'order-limit' ? 'icon-small' : ''));
  textClass = computed(() => this.typography() || (this.variant() === 'order-limit' ? 'body-2' : 'breadcrumb'));
}
